module.exports = __webpack_public_path__ + "static/img/Beau-Fermor.76cc6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Beau-Fermor.jpg
// module id = 6GYl
// module chunks = 0